module.exports = __webpack_public_path__ + "static/media/print_01_B.b8a73603.png";